export const container = `
  h-full w-full overflow-hidden bg-ll-surface
  rounded-md p-3 flex flex-col
`;

export const header = `h-[6%] min-h-5`;

export const body = `grow mx-0 my-2 grid gap-y-1`;

export const footer = `
  border-t border-ll-placeholder border-solid
  h-[6%] min-h-3 w-[calc(100%-165px)]
  ml-[140px] grid grid-cols-3
`;

export const row = `
  grid grid-rows-1 grid-cols-[140px_calc(100%-165px)]
  gap-y-1 items-center
`;

export const bar = `
  relative py-0.5 px-2.5 h-full
  flex justify-start items-center
`;

export const textContainer = `
  z-10 flex items-center justify-center
  h-full w-10 absolute top-0
`;

export const amount = `
  bg-ll-primary rounded-r-md inline-block h-full absolute top-0 bottom-0 left-0
`;
